import saPlay from '@/helpers/saPlay';
import gtagEvent from '@/helpers/gtagEvent';

export default function (wordCard: Element, audioIds: string[]) {
  if (wordCard.hasAttribute('data-audio-id')) {
    const wordCardAudioId = wordCard.getAttribute('data-audio-id');
    if (wordCardAudioId) {
      if (!audioIds.includes(wordCardAudioId)) {
        audioIds.push(wordCardAudioId);
      }
      wordCard.addEventListener('click', () => {
        const audioEl = document.querySelector(`#audio${wordCard.getAttribute('data-audio-id')}`) as HTMLAudioElement;
        if (audioEl) saPlay(audioEl);
        gtagEvent('play_audio_word_card', {
          text: (wordCard as HTMLElement).innerText,
          audio_id: wordCard.getAttribute('data-audio-id'),
        });
      });
    }
  }
  return audioIds;
}
